<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">短信配置</div>
          <div class="card-body">
            <Tabs type="card" :animated="false">
              <TabPane label="基础配置">
                <Alert>
                  短信服务对接说明
                  <template slot="desc">
                    短信服务发货通知买家模块，若无需此功能关闭即可<br />
                    若开启后添加商品时可选择短信发货<br />
                    开启后需前往所使用的短信服务商处申请通知类型模板<br />
                    <span style="color: red">
                      添加模板时模板内容为：您购买的商品已发货，卡密内容：{1}，请查收
                    </span>
                  </template>
                </Alert>
                <Form :model="sms" :label-width="100">
                  <FormItem label="接入厂商">
                    <RadioGroup v-model="sms.sms_type">
                      <Radio label="0">关闭</Radio>
                      <Radio label="1">云之讯</Radio>
                      <!-- <Radio label="2">腾讯云</Radio> -->
                      <!-- <Radio label="3">阿里云</Radio> -->
                      <Radio label="4">易邮</Radio>
                    </RadioGroup>
                  </FormItem>

                  <FormItem>
                    <Button
                      type="primary"
                      @click="Save(basic)"
                      :loading="creating"
                      >保存</Button
                    >
                  </FormItem>
                </Form>
              </TabPane>
              <TabPane label="易邮配置">
                <Alert>
                  易邮短信小量使用价格低个人可接入<br />
                  <template slot="desc">
                    官网地址：<a
                      href="http://sms.eemu.cn"
                      target="_blank"
                      style="color: rgb(87, 163, 243)"
                      >立即前往</a
                    >
                  </template>
                </Alert>
                <Form :model="sms" :label-width="120">
                  <FormItem label="APPKEY">
                    <Input
                      v-model="sms.sms_appkey"
                      placeholder="APPKEY"
                    ></Input>
                  </FormItem>
                  <FormItem label="模板ID">
                    <Input
                      v-model="sms.notice_tid"
                      placeholder="模板ID"
                    ></Input>
                  </FormItem>

                  <FormItem>
                    <Button type="primary" @click="Save()" :loading="creating"
                      >保存</Button
                    >
                  </FormItem>
                </Form>
              </TabPane>
              <TabPane label="云之讯配置">
                <Alert>
                  <template slot="desc">
                    云之讯官网地址：<a
                      href="https://www.ucpaas.com/"
                      target="_blank"
                      style="color: rgb(87, 163, 243)"
                      >立即前往</a
                    >
                  </template>
                </Alert>
                <Form :model="sms" :label-width="100">
                  <FormItem label="Account Sid">
                    <Input
                      v-model="sms.ucpass_sid"
                      placeholder="Account Sid"
                    ></Input>
                  </FormItem>
                  <FormItem label="Auth Token">
                    <Input
                      v-model="sms.ucpass_token"
                      placeholder="Auth Token"
                    ></Input>
                  </FormItem>
                  <FormItem label="APPID">
                    <Input
                      v-model="sms.ucpass_appid"
                      placeholder="APPID"
                    ></Input>
                  </FormItem>
                  <FormItem label="模板ID">
                    <Input
                      v-model="sms.ucpass_tid"
                      placeholder="模板ID"
                    ></Input>
                  </FormItem>

                  <FormItem>
                    <Button type="primary" @click="Save()" :loading="creating"
                      >保存</Button
                    >
                  </FormItem>
                </Form>
              </TabPane>
              
          
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSystem, putSystem } from "@/api/admin";
export default {
  data() {
    return {
      sms: {},
     
      creating: false,
    };
  },
  created() {
    this._getData();
  },

  methods: {
    // 获取列表
    _getData() {
      getSystem("sms").then((res) => {
        this.sms = res.data;
      });
    },
    // 基础配置
    Save() {
      this.creating = true;
      putSystem({
        createData: this.sms,
      }).then((res) => {
        if (res.code == 200) {
          this.$Message.success({
            background: true,
            content: res.msg,
          });
          this._getData();
        } else {
          this.$Message.error({
            background: true,
            content: res.msg,
          });
        }
        this.creating = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.card-body {
  height: 435px;
}
.ivu-radio-wrapper {
  margin-right: 20px;
}
</style>